export default __webpack_public_path__ + "static/media/hop1.00ee32fc.jpg";